<div class="row reports-content poc mat-elevation-z1" style="height: 100%; display: flex; flex-direction: row; gap: 10px;">
    <mat-sidenav-container class="poc-container">
        <mat-sidenav mode="side" opened>
            <mat-nav-list class="mt-4">
                <a mat-list-item href="#"><span class="fw-bold d-flex justify-content-center">Common Items</span></a>
                <mat-divider class="mb-3"></mat-divider>
                <a mat-list-item routerLink="/common-items/items">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em"
                         class="cfa-icon-white">
                        <path fill-rule="evenodd"
                              d="M20.472.097A1.2 1.2 0 0 1 21.2 1.2v21.6A1.2 1.2 0 0 1 20 24h-1.2a1.2 1.2 0 0 1-1.2-1.2v-3.6a1.2 1.2 0 0 1 1.2-1.2v-1.2H14a1.2 1.2 0 0 1-1.2-1.193c-.014-2.224.036-4.615.883-7.173.853-2.576 2.482-5.234 5.489-8.102a1.2 1.2 0 0 1 1.3-.235M18.8 14.4V4.232c-1.47 1.78-2.329 3.417-2.838 4.956-.585 1.764-.732 3.457-.758 5.212zM3.2 1.2a1.2 1.2 0 0 1 1.2 1.2V6a2.4 2.4 0 0 0 1.2 2.078V2.4a1.2 1.2 0 1 1 2.4 0v5.678A2.4 2.4 0 0 0 9.2 6V2.4a1.2 1.2 0 0 1 2.4 0V6A4.8 4.8 0 0 1 8 10.648V22.8a1.2 1.2 0 0 1-2.4 0V10.648A4.8 4.8 0 0 1 2 6V2.4a1.2 1.2 0 0 1 1.2-1.2"
                              clip-rule="evenodd"></path>
                    </svg>
                    <span class="poc-mat-list-item">Menu Items</span>
                </a>
            </mat-nav-list>
            <!-- TODO SM other buttons at bottom, e.g. History, Admin, Info, etc -->
        </mat-sidenav>

        <mat-sidenav-content>
            <div class="poc-router-scrollbar">
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
